import { userConstants } from "../../constant";

const initialState = {
  alerts: [],
  currentAlert: null,
  has_alert: false,
};

export function priceAlerts(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_PRICE_ALERTS:
      return {
        ...state,
        alerts: action.payload.alerts || [],
      };
    case userConstants.SET_PRICE_ALERT:
      return {
        ...state,
        currentAlert: action.payload.alert,
        has_alert: true,
        // Also update the alerts list if we already have it loaded
        alerts: state.alerts.some((a) => a.id === action.payload.alert?.id)
          ? state.alerts.map((a) =>
              a.id === action.payload.alert.id ? action.payload.alert : a
            )
          : [action.payload.alert, ...state.alerts],
      };
    case userConstants.REMOVE_PRICE_ALERT:
      return {
        ...state,
        currentAlert: null,
        has_alert: false,
        alerts: state.alerts.filter(
          (a) => a.product_slug !== action.payload.slug
        ),
      };
    case userConstants.GET_PRICE_ALERT_STATUS:
      return {
        ...state,
        currentAlert: action.payload.alert,
        has_alert: action.payload.has_alert || false,
      };
    default:
      return state;
  }
}
